import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ContactFieldComponent } from './contact-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    ContactFieldComponent,
  ],
  exports: [
    ContactFieldComponent,
  ],
})
export class ContactsExportModule {}
